module.exports = __webpack_public_path__ + "static/media/TALKH.eb3697b3.png";